import { useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import { useLayoutTitle } from "../context/LayoutTitleContext.jsx";
import { useProfileParticipationsRows } from "../hooks/useProfileParticipationsRows.js";
import { isVitrineLoggedIn } from "../lib/wicoopProfileStorage";
import {
  giveawayThumbUrl,
  historyBadgeClass,
  participationsHistory,
  participationsStale,
} from "../utils/profileParticipationsUi.js";
import styles from "./ProfilePage.module.css";

export default function ProfileHistoryPage() {
  const { setPageTitle } = useLayoutTitle();
  const { rows, loading, error } = useProfileParticipationsRows();
  const history = participationsHistory(rows);
  const stale = participationsStale(rows);

  useEffect(() => {
    setPageTitle("История участий");
    return () => setPageTitle(null);
  }, [setPageTitle]);

  if (!isVitrineLoggedIn()) {
    return <Navigate to="/profile/login" replace />;
  }

  return (
    <div className={`${styles.page} ${styles.pageProfile}`}>
      {loading ? <p className={styles.status}>Загрузка…</p> : null}
      {error ? (
        <p className={styles.error} role="alert">
          {error}
        </p>
      ) : null}

      {!loading && !error && history.length === 0 && stale.length === 0 ? (
        <p className={styles.empty}>Пока нет завершённых или ожидающих заявок.</p>
      ) : null}

      {!loading && !error && (history.length > 0 || stale.length > 0) ? (
        <ul className={styles.list}>
          {history.map((r) => {
            const thumb = giveawayThumbUrl(r);
            return (
              <li key={r.giveawayId} className={styles.historyCard}>
                <div className={styles.itemRow}>
                  {thumb ? (
                    <div className={styles.itemThumbWrap}>
                      <img src={thumb} alt="" className={styles.itemThumb} loading="lazy" />
                    </div>
                  ) : null}
                  <div className={styles.itemMain}>
                    <div className={styles.historyTop}>
                      <span className={styles.historyTitle}>{r.giveaway?.title ?? r.giveawayId}</span>
                      <span
                        className={`${styles.historyBadge} ${historyBadgeClass(r.participation, styles)}`}
                      >
                        {r.participation.status_title}
                      </span>
                    </div>
                    <p className={styles.historyNote}>{r.participation.status_subtitle}</p>
                  </div>
                </div>
              </li>
            );
          })}
          {stale.map((r) => {
            const thumb = giveawayThumbUrl(r);
            return (
              <li key={r.giveawayId} className={styles.itemMuted}>
                <div className={styles.itemRow}>
                  {thumb ? (
                    <div className={styles.itemThumbWrap}>
                      <img src={thumb} alt="" className={styles.itemThumb} loading="lazy" />
                    </div>
                  ) : null}
                  <div className={styles.itemMain}>
                    <div className={styles.itemBody}>
                      <span className={styles.itemTitle}>{r.giveaway?.title ?? "Раздача"}</span>
                      <span className={styles.pillMuted}>Сессия недоступна</span>
                    </div>
                    <p className={styles.itemSub}>
                      Сохранённый вход устарел или раздача снята. Можно начать заново с карточки.
                    </p>
                    <Link to={`/giveaway/${r.giveawayId}`} className={styles.linkMuted}>
                      Открыть раздачу
                    </Link>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      ) : null}
    </div>
  );
}
